// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field:not(:last-child) {\r\n  margin-bottom: 1.8em;\n}\r\n", ""]);
// Exports
module.exports = exports;
